import React from 'react';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { FilterProps, OperationType } from 'views/ResourceMapper/types';
import { Row, Typography } from 'syngenta-digital-cropwise-react-ui-kit';
const { Text } = Typography;

const { Option } = Select;
interface UnmappedResourceOperationTypeFilterProps {
  operationTypeFilter: FilterProps<OperationType>;
}

const UnmappedResourceOperationTypeFilter = ({
  operationTypeFilter,
}: UnmappedResourceOperationTypeFilterProps) => {
  const { t } = useTranslation();

  const handleChange = (value: OperationType) => {
    operationTypeFilter.update(value);
  };

  return (
    <Row className="mt-10">
      <Text>{t('resource-mapper.operation_type')}</Text>
      <Select
        defaultValue={OperationType.ALL}
        value={operationTypeFilter.value}
        onChange={handleChange}
        className="w-100%"
        data-testid="operation_type_filter"
      >
        <Option value={OperationType.ALL}>{t('resource-mapper.all_operations')}</Option>
        <Option value={OperationType.APPLICATION}>{t('resource-mapper.application')}</Option>
        <Option value={OperationType.HARVEST}>{t('resource-mapper.harvest')}</Option>
        <Option value={OperationType.PLANTING}>{t('resource-mapper.planting')}</Option>
        <Option value={OperationType.TILLAGE}>{t('resource-mapper.tillage')}</Option>
      </Select>
    </Row>
  );
};

export default UnmappedResourceOperationTypeFilter;
